export const IconTypes = {
  'Audio Recording': 'star_filled',
  Chat: 'star_filled',
  Document: 'document',
  'Email Composition': 'star_filled',
  'Email Reply': 'star_filled',
  Embed: 'embed',
  Flipcard: 'flipcard',
  'Free Response': 'question',
  'Knowledge Check': 'correct',
  Matching: 'correct',
  'Media Recording': 'new_video',
  'Multiple Choice': 'question',
  'Multiple Select': 'question',
  Paragraph: 'text',
  Photo: 'photo',
  Question: 'question',
  'Question Bank': 'question',
  Reveal: 'reveal',
  'Screen Recording': 'video_camera',
  Sorting: 'correct',
  Survey: 'question',
  'Ticket Handling': 'star_filled',
  'Upload Response': 'question',
  Video: 'video',
  'Webcam Recording': 'video_camera',
  'Written Response': 'question',
};
